export default __webpack_public_path__ + "static/media/banner-2.b927aaca.jpg";